module.exports = __webpack_public_path__ + "static/preview-user-lists-scale-large-e6a94d6986f12d30aa16261fa4d33e2e.png";